export const DEFAULT_WEBSTUDIO_API_BASE_URL = 'https://webstudio.pranathiss.com';

type WebstudioApiBaseUrlEnvName =
  | 'NEXT_PUBLIC_VERSION_API_BASE_URL'
  | 'NEXT_PUBLIC_WHATS_NEW_API_BASE_URL';

export function configuredWebstudioApiBaseUrl(
  endpointEnvName?: WebstudioApiBaseUrlEnvName,
): string {
  const endpointBaseUrl = endpointEnvName
    ? process.env[endpointEnvName]?.trim()
    : undefined;
  if (endpointBaseUrl) return endpointBaseUrl;

  const sharedBaseUrl = process.env.NEXT_PUBLIC_WEBSTUDIO_API_BASE_URL?.trim();
  return sharedBaseUrl || DEFAULT_WEBSTUDIO_API_BASE_URL;
}

export function webstudioApiUrl(path: string): string {
  try {
    return new URL(path, configuredWebstudioApiBaseUrl()).toString();
  } catch {
    return new URL(path, DEFAULT_WEBSTUDIO_API_BASE_URL).toString();
  }
}
